import PropTypes from 'prop-types';
import { useNavigate, NavLink as RouterLink } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// @mui
import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItemText } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import style from './NavSection.module.css';
import ProtectedComponent from '../protected/ProtectedComponent';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const navigate = useNavigate();
  const handleParentClick = (path) => () => navigate(path);
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <ProtectedComponent permission={item.permission} key={item?.title} hide={item?.hide}>
            {item.children ? (
              <Accordion className={style.accordion}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className={style.accordionSummary}
                  onClick={handleParentClick(item?.path)}
                >
                  <NavItem key={item.title} item={item} />
                </AccordionSummary>
                <AccordionDetails className={style.accordionDetails}>
                  <List>
                    {item.children.map((item) => (
                      <NavItem key={item.title} item={item} />
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            ) : (
              <NavItem key={item.title} item={item} />
            )}
          </ProtectedComponent>
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

export function NavItem({ item }) {
  const { title, path, icon, info } = item;
  const navItemProps = path
    ? {
        component: RouterLink,
        to: path,
      }
    : {};

  return (
    <StyledNavItem
      {...navItemProps}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info}
    </StyledNavItem>
  );
}
